<app-fat-top-bar-layout [setupObs]="layoutSetup"  [showSitesSelector]="true"></app-fat-top-bar-layout>